import { colors, COLORS } from '@constants/colors';

import { useMytaverse } from '@providers/MytaverseProvider';

export const useStyles = () => {
  const { appTheme } = useMytaverse();

  return {
    root: {
      display: 'flex',
      alignItems: 'center',
      mt: 1,
      width: '100%',
    },

    icon: {
      color: COLORS.GREY,
    },

    linearProgress: {
      width: '100%',
      maxWidth: 320,
      pt: 0.5,
      borderRadius: 2,
      background: colors.grey_third,

      '& span': {
        background: appTheme.mainColor,
      },
    },
  };
};
